import React from "react";
//#region types
import { SimpleTooltipProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { Tooltip } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const SimpleTooltip: React.FC<SimpleTooltipProps> = (props) => {
  const childElement = React.useRef<any>(null);
  const [isOverflowing, setIsOverflowing] = React.useState(false);

  const FieldElement = <props.children.type {...props.children.props} ref={childElement} />;

  React.useEffect(() => {
    setIsOverflowing(checkOverflow(childElement.current));
  }, []);

  const checkOverflow = (el: any) => {
    if (el === undefined || el === null) return false;

    const curOverflow = el?.style.overflow;

    if (!curOverflow || curOverflow === "visible") el.style.overflow = "hidden";
    const isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;

    el.style.overflow = curOverflow;

    return isOverflowing;
  };

  return props.text && (!props.showOnlyOnOverflow || isOverflowing) ? (
    <Tooltip
      disableInteractive
      placement={props.placement ?? "top"}
      title={props.text}
      arrow
      classes={{
        tooltip: clsx(cssExports.tooltip, props.hidden ? cssExports.hidden : ""),
        popper: cssExports.tooltipPopper,
        arrow: cssExports.tooltipArrow,
      }}
    >
      {FieldElement}
    </Tooltip>
  ) : (
    FieldElement
  );
};

export default SimpleTooltip;
